import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import SocialOfferDetails from "./socialOffer";

const OfferDetail = lazy(() => import("./details"));
const JobOffersDashboard = lazy(() => import("./dashboard/job"));
const SocialOffersDashboard = lazy(() => import("./dashboard/social"));
const ErrorPage = lazy(() => import("@root/error"));

export const offersRoutes: RouteObject[] = [
  {
    path: "/v2/offers/dashboard/job",
    element: <JobOffersDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/offers/dashboard/social",
    element: <SocialOffersDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/offer/:id",
    element: <OfferDetail />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/offer/social/:offerId",
    element: <SocialOfferDetails />,
    errorElement: <ErrorPage />,
  },
];
